export default "__VITE_ASSET__D3AjPgwd__ 584w";